import { useState, type FormEvent } from "react";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { AuthCard } from "./AuthCard";
import { useLogin } from "./session";

export function LoginPage() {
  const login = useLogin();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const submit = (e: FormEvent) => {
    e.preventDefault();
    login.mutate({ username, password }, { onSettled: () => setPassword("") });
  };

  return (
    <AuthCard title="AVGV" subtitle="Audio / Video / Geo Viewer" onSubmit={submit}>
      <TextField
        label="Username"
        autoComplete="username"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
        required
        autoFocus
      />
      <TextField
        label="Password"
        type="password"
        autoComplete="current-password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        required
      />
      {login.isError && <Alert severity="error">{login.error.message}</Alert>}
      <Button type="submit" variant="contained" size="large" disabled={login.isPending}>
        Sign in
      </Button>
    </AuthCard>
  );
}
